import styled, { css } from 'styled-components';
import { ReactComponent as Info } from '../../../../assets/icons/icon_info.svg';
import { borderRadius, colors, spacing, transitions, typography } from '../../../../styles/theme';
import BaseIcon from '../../Icon';

interface IconProps {
  readonly checked: boolean;
}

export const Row = styled.a`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colors('default.base')};
  padding: ${spacing('2')} 0;
  cursor: pointer;
  transition: ${transitions('fast')};

  position: relative;

  :hover {
    background-color: ${colors('default.light')};
    transition: ${transitions('fast')};
  }
`;

export const Title = styled.p`
  font-size: ${typography('fontSize')};
  font-weight: ${typography('weights.semibold')};
  margin-bottom: ${spacing('small')};
  padding-right: 120px;
`;

export const Icon = styled(BaseIcon)<IconProps>`
  float: left;
  font-size: 24px;
  margin-right: ${spacing('2')};
  opacity: 0.1;

  ${({ checked }: IconProps) =>
    checked &&
    css`
      opacity: 1;
    `}
`;

export const Tag = styled.span`
  display: inline-block;
  padding: ${spacing('extraSmall')} ${spacing('small')};
  border: 1px solid ${colors('accent.base')};
  border-radius: ${borderRadius('base')};
  font-weight: ${typography('weights.regular')};
  color: ${colors('accent.base')};
  background-color: ${colors('white.50')};

  &.blocked {
    color: ${colors('neutral.base')};
    border-color: ${colors('neutral.base')};
    margin-right: ${spacing('1')};
  }
`;

export const IconInfo = styled(Info)`
  font-size: 24px;
`;

export const CompositionsList = styled.div`
  font-size: ${typography('caption1.fontSize')};
  line-height: ${typography('caption1.lineHeight')};
  color: ${colors('neutral.base')};
`;

export const TagContainer = styled.div`
  position: absolute;
  top: ${spacing('2')};
  right: 0;

  margin-right: ${spacing('1')};

  .tooltip_content {
    display: flex;
    align-items: center;
  }
`;
